import React from 'react';
import { Link } from 'react-router-dom';
import { TOURIST_PLAN_GROUPS, planStepsForRail } from '../../data/touristNavigation';

function HomePlanPanel() {
	return (
		<div className="home-panel home-panel--alt">
			<div className="home-panel__head">
				<div>
					<h2 className="home-panel__title">Plan your trip</h2>
					<p className="home-panel__lead">
						Pick a topic below. Each page is self-contained — read the info, then use Next to continue in order.
					</p>
				</div>
			</div>

			{TOURIST_PLAN_GROUPS.map((group) => (
				<div key={group.id} className="home-plan-phase">
					<h3 className="home-plan-phase__name">{group.title}</h3>
					<div className="home-guides">
						{planStepsForRail(group.steps).map((step) => (
							<Link key={step.id} to={step.route} className="home-guides__pill home-guides__pill--large">
								{step.label}
							</Link>
						))}
					</div>
				</div>
			))}
		</div>
	);
}

export default HomePlanPanel;
